import React, { useState, useRef } from "react";
import { Toast } from "zarm";
import { clearObj, getFormId } from "../../utils/tools";
import UItem from "../item";
import SearchPopup from "./searchPopup";

import { InputAddressProps } from "./type";
import InputBase from "./inputBase";

// 表单 输入框组件
function Address(props: InputAddressProps) {
  const {
    type,
    value,
    className,
    disabled,
    defaultValue = "",
    maxLength,
    placeholder,
    readOnly,
    readonly,
    _crengine,
    clearable,
    showLength,
    sourceName = "city",
    onChange,
    onLog,
    ...rest
  } = props;
  const newReadOnly = readOnly || readonly;
  const initialValue = value || defaultValue || "";
  const { form, path, dataBind } = _crengine || {};

  const [popupData, setPopupData] = useState({ visible: false });
  const inputRef = useRef<HTMLInputElement | null>(null);

  // 获取焦点 唤起弹框
  const onFocus = () => {
    const names = getFormId(sourceName, path);
    if (form) {
      const city = form.getFieldValue(names);
      if (city) {
        setPopupData({ visible: true });
        if (inputRef.current) {
          inputRef.current.blur();
        }
      } else {
        if (inputRef.current) {
          inputRef.current.blur();
        }
        Toast.show("请先填写地址");
      }
    } else {
      console.error("address 组件必须有form");
    }
  };

  // 选择完成赋值并且关闭弹框
  const onPopupOk = popupValue => {
    setPopupData({
      visible: false
    });
    if (form) {
      const { onChange: onChangeV, ...otherProps } = props;
      const names = getFormId(dataBind, path);
      form.setFieldsValue({
        [names]: popupValue
      });
      if (onChangeV) {
        onChangeV({
          ...otherProps,
          value: popupValue
        });
      }
    }else {
      console.error('onPopupOk form 不存在');
    }
  };

  // 弹框点击返回按钮 关闭弹框
  const onPopupBack = () => {
    setPopupData({
      visible: false
    });
  };

  const inputProps = clearObj({
    type,
    disabled,
    defaultValue,
    value,
    maxLength,
    clearable,
    showLength,
    placeholder,
    readOnly: newReadOnly,
    onFocus
  });

  // 如果wform存在 则去除input组件的某些属性
  if (form) {
    delete inputProps.value;
    delete inputProps.defaultValue;
  }

  return (
    <div>
      <UItem {...rest} _crengine={_crengine} initialValue={initialValue} onChange={onChange}>
        <InputBase {...inputProps} ref={inputRef} />
      </UItem>
      <SearchPopup visible={popupData.visible} onOk={onPopupOk} onBack={onPopupBack} {...props} />
    </div>
  );
}

export default Address;
